import { makeAutoObservable } from 'mobx';
import { routerStoreInterface } from "utils/mobx/mobxInterface";
import SystemInfoStore from "../SystemInfoStore";

const defaultRouterStoreDate: routerStoreInterface = {
    path: `${window.location.pathname}`,
    lastPath: ""
}
class Store {
    path: string;
    lastPath: string;

    constructor(routerStore: routerStoreInterface) {
        makeAutoObservable(
            this,
            {

            },
            {
                autoBind:true
            }
        );
        this.path = routerStore.path
        this.lastPath = routerStore.lastPath
    }

    setPath(path: string): void {
        this.path = path;
    }

    setLastPath(path: string): void {
        this.lastPath = path;
    }

    setRouterPath(siderMenuProps: any): void {
        const {userInfo} = SystemInfoStore
        if (!(siderMenuProps?.parentId === "0" && !siderMenuProps?.url)) {
            this.lastPath = this.path
            if (siderMenuProps?.url !== "/") {
                this.path = `${userInfo?.businessId}${siderMenuProps?.url}${
                    // siderMenuProps?.magicId ? `?id=${siderMenuProps?.magicId}` : ""
                    siderMenuProps?.magicId ? `?id=${siderMenuProps?.id}` : ""
                }`;
            } else {
                this.path = `/${siderMenuProps?.url}`
            }
        }
    }

}

const RouterStore: Store = new Store(defaultRouterStoreDate);

export default RouterStore;